/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadContentType } from './UploadContentType';
import {
    UploadContentTypeFromJSON,
    UploadContentTypeFromJSONTyped,
    UploadContentTypeToJSON,
    UploadContentTypeToJSONTyped,
} from './UploadContentType';

/**
 * 
 * @export
 * @interface UploadFileInput
 */
export interface UploadFileInput {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    content_type: UploadContentType;
    /**
     * 
     */
    size: number;
    /**
     * Base64 SHA-256 of the file bytes
     */
    sha256: string;
}



/**
 * Check if a given object implements the UploadFileInput interface.
 */
export function instanceOfUploadFileInput(value: object): value is UploadFileInput {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('content_type' in value) || value['content_type'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('sha256' in value) || value['sha256'] === undefined) return false;
    return true;
}

export function UploadFileInputFromJSON(json: any): UploadFileInput {
    return UploadFileInputFromJSONTyped(json, false);
}

export function UploadFileInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadFileInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'content_type': UploadContentTypeFromJSON(json['content_type']),
        'size': json['size'],
        'sha256': json['sha256'],
    };
}

export function UploadFileInputToJSON(json: any): UploadFileInput {
    return UploadFileInputToJSONTyped(json, false);
}

export function UploadFileInputToJSONTyped(value?: UploadFileInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'content_type': UploadContentTypeToJSON(value['content_type']),
        'size': value['size'],
        'sha256': value['sha256'],
    };
}

